import {
  type ActiveCohortBuilderItemLegacy,
  type ActiveIndexDateItemLegacy,
  type CohortBuilderDefinitionLegacy,
  CohortBuilderModalLegacy,
} from '@verantos-dev/types-cohorts';

export const getRequiredDataFromState = (
  cohortDefinition: CohortBuilderDefinitionLegacy,
  nextActiveCohortBuilderItem: ActiveCohortBuilderItemLegacy,
  modal: CohortBuilderModalLegacy | undefined
) => {
  /** Pull data from the nextActiveCohortBuilderItem */
  const {
    id,
    name,
    type,
    anyOrder,
    conceptFilters,
    numericFilters,
    relatedEntityFilters,
    eventFilters,
    temporalConstraints,
    uniquenessFilters,
    countFilter,
  } = nextActiveCohortBuilderItem;

  let indexDateValue = '';
  if (
    modal !== undefined &&
    [CohortBuilderModalLegacy.ADD_INDEX_DATE, CohortBuilderModalLegacy.EDIT_INDEX_DATE].includes(
      modal
    )
  ) {
    const { indexDateValue: _indexDateValue } =
      nextActiveCohortBuilderItem as ActiveIndexDateItemLegacy;
    indexDateValue = _indexDateValue ?? '';
  }

  /** Pull data from the current cohortDefinition */
  const {
    studyPeriodRestrictions,
    indexDate: currentIndexDate,
    subjectVariables,
    simpleEvents,
    derivedEvents,
  } = cohortDefinition;
  const currentSubjectVariable = subjectVariables?.find((variable) => variable.id === id);
  const currentSimpleEvent = simpleEvents?.find((event) => event.id === id);
  const currentDerivedEvent = derivedEvents?.find((event) => event.id === id);

  return {
    /** The value of the current cohort builder item in the definition */
    currentSubjectVariable,
    currentIndexDate,
    currentDerivedEvent,
    currentSimpleEvent,

    /** data from cohortDefinition */
    studyPeriodRestrictions,
    subjectVariables,
    simpleEvents,
    derivedEvents,

    /** data from nextActiveCohortBuilderItem */
    id,
    name,
    type,
    anyOrder,
    conceptFilters,
    numericFilters,
    eventFilters,
    temporalConstraints,
    relatedEntityFilters: relatedEntityFilters ?? [],
    uniquenessFilters: uniquenessFilters ?? [],
    countFilter,
    indexDateValue,
  };
};
